import styled from 'styled-components';

export const SpinWheelWidgetStyled = styled.div`
  text-align: center;
  img {
    width: 348px;
    height: auto;
  }
`;
